import { IonButton } from "@ionic/react";
import React from "react";
import { Button_AI_Assist } from "@assets/images";

type Props = {
  buttonPressed?: () => void;
};

const AIAssistButton: React.FC<Props> = (props) => {
  return (
    <div className="flex justify-end">
      <IonButton
        mode="ios"
        className="ai-assist-button flex !h-14 !w-14 bg-ai-assist-button shadow-[0px_4px_10.600000381469727px_0px_rgba(0,0,0,0.25)]"
        onClick={props.buttonPressed}
      >
        <div className="flex items-center gap-3.5">
          <img
            src={Button_AI_Assist}
            className="h-7 w-4"
          />
        </div>
      </IonButton>
    </div>
  );
};

export default AIAssistButton;
